var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasData)?_c('p',{staticClass:"paginage-msg"},[_vm._v(_vm._s(_vm.moreDataTitle))]):_c('p',{staticClass:"paginage-msg"},[_vm._v(_vm._s(_vm.noDataTitle))])
}
var staticRenderFns = []

export { render, staticRenderFns }